import { render, staticRenderFns } from "./MemberInstitution.vue?vue&type=template&id=7d6d08ba"
import script from "./MemberInstitution.vue?vue&type=script&lang=js"
export * from "./MemberInstitution.vue?vue&type=script&lang=js"
import style0 from "./MemberInstitution.vue?vue&type=style&index=0&id=7d6d08ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports